import React, { forwardRef } from 'react';
import { Button } from '@chakra-ui/react'; // Assuming you're using Chakra UI
import type { ButtonProps } from '@chakra-ui/react'; // Import ButtonProps type
import { themeVariables } from '@meteraprotocol/sdk/ui/theme.js';

const NeutralButton = forwardRef<HTMLButtonElement, ButtonProps>(
  (props, ref) => (
    <Button
      ref={ref}
      textColor={themeVariables.primary.primary50}
      fontSize=".875rem"
      borderRadius="22px"
      background={themeVariables.gradient.button}
      border={`1px solid ${themeVariables.cards.stroke}, rgba(139, 93, 247, 0.35)`}
      _hover={{
        background: themeVariables.gradient.button100,
      }}
      _active={{
        bg: '#414a60',
      }}
      {...props}
    />
  ),
);

export default NeutralButton;
